import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectLEAManagementDataEntryMode } from '../../../redux/slices/leaManagementSlice';
import { DataEntryMode } from '../../../types/DataEntryMode';
import { LEAManagementModel } from '../../../types/LEAManagementModel';
import { PanelType } from '../../../types/PanelType';
import { LEAManagementValidationEditSchema } from '../../../types/Validation/LEAManagementValidationEditSchema';
import { LEAManagementValidationSchema } from '../../../types/Validation/LEAManagementValidationSchema';
import {
  isDistrictAdminAssignedToDistrict,
  isStateAdmin,
} from '../../../utilities/userUtilities';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';

const LEAManagementPrimaryInformationPanel = (): ReactElement => {
  const { values } = useFormikContext<LEAManagementModel>();
  const dataEntryMode: DataEntryMode = useAppSelector(
    selectLEAManagementDataEntryMode
  );
  const canEdit =
    isStateAdmin() || isDistrictAdminAssignedToDistrict(values.leaIdentifier);

  return (
    <Panel panelType={PanelType.INFO} heading="MSIS Primary Information">
      <div className="field-row">
        <FormTextbox
          displayName="First Name"
          field="primaryFirstName"
          validationSchema={
            dataEntryMode === 'new'
              ? LEAManagementValidationSchema
              : LEAManagementValidationEditSchema
          }
          disabled={!canEdit}
        />
        <FormTextbox
          displayName="Last Name"
          field="primaryLastName"
          validationSchema={
            dataEntryMode === 'new'
              ? LEAManagementValidationSchema
              : LEAManagementValidationEditSchema
          }
          disabled={!canEdit}
        />
      </div>

      <div className="field-row">
        <FormTextbox
          displayName="Email Address"
          field="primaryEmailAddress"
          validationSchema={
            dataEntryMode === 'new'
              ? LEAManagementValidationSchema
              : LEAManagementValidationEditSchema
          }
          disabled={!canEdit}
        />
        <FormTextbox
          displayName="Telephone Number"
          field="primaryTelephoneNumber"
          validationSchema={
            dataEntryMode === 'new'
              ? LEAManagementValidationSchema
              : LEAManagementValidationEditSchema
          }
          disabled={!canEdit}
        />
      </div>
    </Panel>
  );
};

export default LEAManagementPrimaryInformationPanel;
